// 获取数据类型
const getInstance = function(data) {
  // "[object Array]"
  const instanceStr = Object.prototype.toString.call(data);
  const index = instanceStr.indexOf(" ");
  return instanceStr.substring(index + 1, instanceStr.length - 1);
};
const checkBindingValue = function(data) {
  if (data === undefined) return false;
  // 判断时间
  if (Number.isNaN(data)) {
    console.error(`[v-click-throttle] 参数类型错误: ${getInstance(data)}. 请输入数字`);
    return;
  } else if (data < 0) {
    console.error("[v-click-throttle] 参数错误,不能小于0");
    return;
  } else {
    return data;
  }
};
let bindingValue = false; // 校验

export default {
  inserted: (el, binding) => {
    const { value } = binding;
    let timer = null;
    // 默认500ms
    const timeout = +(value || 0.5);

    // 判断外界影响节流因素
    bindingValue = checkBindingValue(timeout);

    if (!bindingValue) {
      return;
    }

    el.parentElement &&
      el.parentElement.addEventListener(
        "click",
        (e) => {
          if (timer) {
            e.stopPropagation();
            return;
          }
          timer = setTimeout(() => {
            clearTimeout(timer);
            timer = null;
          }, timeout * 1000);
        },
        true
      );
  },
  update: (_, binding) => {
    // 判断外界影响节流因素
    bindingValue = checkBindingValue(binding.value);
  }
};
